<script scoped>
import axios from "axios";
import Swal from "sweetalert2";

export default {
  name: "ModalEditTresholdNilai",
  props: ["selectedData", "jadwal_id"],
  watch: {
    selectedData: function (newVal, oldVal) {
      if (newVal != oldVal) {
        this.formData = newVal;
        this.level = newVal?.level_kompetensi?.nama_level;
      }
    },
  },
  emits: ["submitTresholdNilai"],
  data() {
    return {
      formData: this.$props.selectedData,
      level: "",
    };
  },
  methods: {
    submitForm() {
      let url =
        process.env.VUE_APP_BACKEND_URL_VERSION +
        `master/jadwal-pelaksanaan/${this.formData.jadwal_id}/setup-jadwal/jadwal-treshold-nilai`;
      let formData = {
        jadwal_idjadwal: this.jadwal_id,
        idjadwal_treshold_nilai: this.formData.idjadwal_treshold_nilai,
        kompetensi_level: this.formData.kompetensi_level,
        nilai_text: this.formData.nilai_text,
        treshold_dari: this.formData.treshold_dari,
        treshold_sampai: this.formData.treshold_sampai,
      };

      var config = {
        method: "post",
        url: url,
        data: formData,
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.access_token,
        },
      };

      axios(config)
        .then((response) => {
          console.log("Response:", response.data);
          Swal.fire({
            icon: "success",
            title: "Berhasil",
            // text: response.data.meta.message,
          });
          this.$emit("submitTresholdNilai");
        })
        .catch((error) => {
          // Handle errors
          Swal.fire({
            icon: "error",
            title: "Gagal",
            text: error.response.data.meta.message,
          });
          console.error("Error:", error.response.data);
        });
    },
  },
};
</script>
<template>
  <div class="container">
    <form @submit.prevent="submitForm">
      <table border="0">
        <tr class="mb-3">
          <td>
            <label class="form-label">Level Kompetensi</label>
          </td>
          <td>
            <label class="form-label">: {{ level }}</label>
          </td>
        </tr>
        <tr class="mb-3">
          <td>
            <label class="form-label">Nilai Text</label>
          </td>
          <td>
            <label class="form-label">: {{ formData.nilai_text }}</label>
          </td>
        </tr>
      </table>
      <div class="form-group mb-3">
        <label for="treshold_dari">Treshold Dari</label>
        <input
          type="text"
          class="form-control"
          id="treshold_dari"
          v-model="formData.treshold_dari"
          required
        />
      </div>
      <div class="form-group mb-3">
        <label for="treshold_sampai">Treshold Sampai</label>
        <input
          type="text"
          class="form-control"
          id="treshold_sampai"
          v-model="formData.treshold_sampai"
          required
        />
      </div>
      <button type="submit" class="btn btn-primary float-end">Simpan</button>
    </form>
  </div>
</template>
